import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useStoreActions } from '~/store/store-context';
import { useInvalidateContactIdentity } from './useContactSummaryMutations';
export const useUpdateClientContactRole = ()=>{
    const { api } = useStoreActions();
    const invalidateContactIdentity = useInvalidateContactIdentity();
    const { mutateAsync } = useMutationState({
        mutationFn: (_0)=>{
            let { clientContactId } = _0, data = _object_without_properties(_0, [
                "clientContactId"
            ]);
            return api.clientContact.updateRole(clientContactId, data);
        },
        onSuccess: invalidateContactIdentity
    });
    return {
        updateClientContactRole: mutateAsync
    };
};
export const useUpdateNativeContactRole = ()=>{
    const { api } = useStoreActions();
    const invalidateContactIdentity = useInvalidateContactIdentity();
    const { mutateAsync } = useMutationState({
        mutationFn: (_0)=>{
            let { userId } = _0, data = _object_without_properties(_0, [
                "userId"
            ]);
            return api.user.updateBuyerRole(userId, data);
        },
        onSuccess: invalidateContactIdentity
    });
    return {
        updateNativeContactRole: mutateAsync
    };
};
